<section class="container-fluid">
  <div class="row py-2"></div>
  <div class="row">
    <div class="col-md-4 col-lg-3 col-12 mb-2">
      <div class="form-floating">
        <input type="date" class="form-control" [(ngModel)]="fromDate" [max]="toDate" (change)="onDateChange()">
        <label>From Date <span class="text-danger">*</span></label>
      </div>
    </div>

    <div class="col-md-4 col-lg-3 col-12 mb-2">
      <div class="form-floating">
        <input type="date" class="form-control" [(ngModel)]="toDate" [max]="currentDate" (change)="onDateChange()">
        <label>To Date <span class="text-danger">*</span></label>
      </div>
    </div>

    <!-- Scrollable Table Container -->
    <div class="table-responsive mt-4 table-wrapper-scroll-y tableFixHead">
      <table class="table table-bordered table-hover table-rounded text-center">
        <thead class="sticky-top table-primary">
          <tr>
            <th>#</th>
            <th>Employee Id</th>
            <th>Name</th>
            <th>Working Days</th>
            <th>Leave Days</th>
            <th>Save</th>
          </tr>
        </thead>
        <tbody *ngIf="employeeData.length > 0; else noDataFound">
          <tr *ngFor="let employee of employeeData; let i = index">
            <td>{{i+1}}</td>
            <td>{{employee?.newJoinId}}</td>
            <td>{{employee?.employeeName}}</td>
            <td><input type="number" [(ngModel)]="workingDaysMap[i]" class="form-control" readonly></td>
            <td>
              <input type="number" [(ngModel)]="leaveDaysMap[i]" class="form-control" (input)="updateWorkingDays(i)"
                min="0">
            </td>
            <td>
              <button type="button" class="btn btn-primary" (click)="onSave(i)"
                [disabled]="savedRecords.has(i)">Save</button>
            </td>
          </tr>
        </tbody>
        <ng-template #noDataFound>
          <tr>
            <td colspan="6">Data Not Found</td>
          </tr>
        </ng-template>
      </table>
    </div>
  </div>
</section>
